// angular
import { Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// dialogs
import {
  getVideoPreviewDialogConfig,
  VideoPreviewDialogComponent,
} from '@app/core/dialogs/video-preview-dialog/video-preview-dialog.component';
// services
import { DialogService } from '@app/core/shared/services/dialog.service';
// interfaces
import { IMedia } from '@app/shared/interfaces/media.interface';
// utils
import {
  mediaDisplayName,
  resolveMediaFileUrl,
  resolveVideoPosterPath,
} from '@app/shared/utils/media.util';
import { environment } from '@environments/environment';
// pipes
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';

@Component({
  selector: 'pwj-media-videos-grid',
  standalone: true,
  imports: [TranslateModule, ImageSourcePipe],
  providers: [ImageSourcePipe],
  templateUrl: './media-videos-grid.component.html',
  styleUrl: './media-videos-grid.component.scss',
})
export class MediaVideosGridComponent {
  videos = input.required<IMedia[]>();
  showTitle = input(false);
  titleKey = input('personDetail.videos');
  sectionId = input<string | undefined>(undefined);
  embedded = input(false);

  private readonly _dialogService = inject(DialogService);
  private readonly _imageSourcePipe = inject(ImageSourcePipe);

  public videoSrc(video: IMedia): string {
    return resolveMediaFileUrl(video?.url, environment.baseUrl.file);
  }

  public videoPoster(video: IMedia): string {
    const path = resolveVideoPosterPath(video);
    return path ? (this._imageSourcePipe.transform(path) ?? '') : '';
  }

  public hasVideoPoster(video: IMedia): boolean {
    return !!resolveVideoPosterPath(video);
  }

  public primeVideoFrame(event: Event): void {
    const video = event.target as HTMLVideoElement;
    if (video.currentTime === 0) {
      video.currentTime = 0.01;
    }
  }

  public videoDisplayName(video: IMedia): string {
    return mediaDisplayName(video);
  }

  public openVideoDialog(videoUrl: string): void {
    if (!videoUrl.trim()) {
      return;
    }

    this._dialogService.open(VideoPreviewDialogComponent, {
      ...getVideoPreviewDialogConfig(),
      data: { url: videoUrl },
    });
  }
}
